import { createStore } from 'vuex';
import axios from 'axios';

const store = createStore({
    state: {
        funds: [],
        isFundsFetched: false,
    },
    mutations: {
        SET_FUNDS(state, funds) {
            state.funds = funds;
            state.isFundsFetched = true;
        }
    },
    actions: {
        async fetchFunds({ state, commit }) {
            if (state.isFundsFetched) {
                return state.funds; 
            }
            try {
                const baseURL = process.env.VUE_APP_BASE_URL;
                const response = await axios.get(`${baseURL}/wp-admin/admin-ajax.php?action=prime_etf_reco`);
                const mappedFunds = response.data.map(fund => ({
                    name: fund.s_name,
                    primeRating: fund.prime_rating,
                    oneYearReturn: fund.one_year_return,
                    threeYearCAGR: fund.three_year_return,
                    fiveYearCAGR: fund.five_year_return,
                    subCategory: fund.prime_category,
                    schemeCode: fund.schemecode,
                    comment: fund.comment,
                    alert: fund.alert

                }));
                commit('SET_FUNDS', mappedFunds);
                return mappedFunds;
            } catch (error) {
                    console.error('Error fetching funds from API:', error);
                    throw error; 
            }
        }        
    },
    getters: {
        funds: (state) => state.funds,
        getDebtGoldData: (state) => state.funds.filter(fund => fund.subCategory === 'debt-gold'),
        getHighRiskFunds: (state) => state.funds.filter(fund => fund.subCategory === 'high-risk'),
        getModerateRiskFunds: (state) => state.funds.filter(fund => fund.subCategory === 'moderate-risk'),
        getThemeFunds: (state) => state.funds.filter(fund => fund.subCategory === 'themes-strategies')
    },
});

export default store;
